import React from "react";
import { useMutation } from "@tanstack/react-query";
import { Flex, theme, App } from "antd";
import { AxiosError, HttpStatusCode } from "axios";
import { useContext, useEffect } from "react";
import { SessaoARContext, TypeSessaoContext } from "../../Contexts/SessaoContext";
import { Axios, configurarSessaoDoAxios } from "../../../Services/Axios";
import { LOCAL_STORAGE_JWT_KEY_AREA_RESTRITA } from "../../../Constants";
import { AreaRestritaUsuarioService } from "../../../Services/Domain/AreaRestrita/UsuarioService";
import { TypeSessaoDaAreaRestrita } from "../../../Models/Domain/AreaRestrita/Sessao";

export const CancelarSessaoERemoverToken = (setSessao?: TypeSessaoContext['setSessao'] ) => {
    if(setSessao == undefined) return;

    Axios.interceptors.response.clear();
    localStorage.removeItem(LOCAL_STORAGE_JWT_KEY_AREA_RESTRITA);
    setSessao({});
}

/**
 * Verifica a validade do token JWT armazenado no `localStorage`. 
 * Caso o token seja válido, a sessão do usuário é configurada e mantida.
 * Em caso de erro na validação (como conexão de rede ou token inválido), a sessão é cancelada e o token é removido.
 */
export function Splash(props: { temaEscuro: boolean }) {
    const { notification } = App.useApp();
    const SessaoAR = useContext(SessaoARContext);

    const service = new AreaRestritaUsuarioService();

    const validarToken = useMutation({
        mutationFn: (token: string) => {
            return service.validarToken(token);
        },
        onSuccess: (data) => {
            const dadosDaSessao = data.data;

            configurarSessaoDoAxios(dadosDaSessao.token!, () => CancelarSessaoERemoverToken(SessaoAR?.setSessao));
            SessaoAR?.setSessao(dadosDaSessao);
        },
        onError: (error: AxiosError) => {
            if (error.cause?.cause === AxiosError.ERR_NETWORK || error.cause?.cause === AxiosError.ETIMEDOUT){
                notification.error({ message: "Verifique a conexão com a internet.", placement: "top" });
                return;
            }
            if( error.status === HttpStatusCode.Forbidden){
                CancelarSessaoERemoverToken(SessaoAR?.setSessao);
            }

            SessaoAR?.setSessao({});
        }
    });

    useEffect(() => {
        const f = () => {
            const token = localStorage.getItem(LOCAL_STORAGE_JWT_KEY_AREA_RESTRITA);

            if (token == undefined || token.trim() == "") {
                SessaoAR?.setSessao({})
                return;
            };

            validarToken.mutate(token);
        }

        setTimeout(() => {
            f();
        }, 1000);
        
    }, [])

    return (
        <>
            <style>
                {`
            .loginBackground{
                background: linear-gradient(-45deg, ${theme.useToken().token.colorPrimary} 30%, ${theme.useToken().token.colorBgBase} 70%);
                background-size: 150% 150%;
                animation: gradient 10s ease infinite;
                height: 100vh;
            }
            @keyframes gradient {
                0% {
                  background-position: 0% 50%;
                }
                50% {
                  background-position: 50% 75%;
                }
                100% {
                  background-position: 0% 50%;
                }
            }`
                }
            </style>
            <Flex justify="center" align="center" className="loginBackground">
                <img alt="Logo Quiron" src={require('../../../Assets/logo-quiron.png')} style={{ width: '200px', textAlign: 'center' }} />
            </Flex>
        </>
    )
}
